'use client';

import { useEffect, useRef } from 'react';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { useIsWebview } from '@flipster/features/src/shared/webview';
import { languageTagToSupportedLocale } from '@flipster/i18n/constants';
import { useSupportedLocale } from '@flipster/i18n/hooks';
import { usePathname, useRouter } from '@flipster/i18n/routing';

/**
 * 유저가 설정한 언어와 다른 언어로 접근하려고 하면 리다이렉트
 */
export const UserLanguageRedirect = () => {
  const { user } = useAuth();
  const currentLocale = useSupportedLocale();
  const pathname = usePathname();
  const router = useRouter();
  const hasRedirectedRef = useRef(false);
  const isWebview = useIsWebview();

  useEffect(() => {
    if (isWebview) return;
    // 이미 리다이렉트했거나 언어설정 확인이 되지 않으면 실행하지 않음
    if (hasRedirectedRef.current || !user?.redirectLocale) return;

    // Does not support en-AE as user.lang
    // en-AE is only supported as user.redirectLocale
    const userRedirectLocale = user.redirectLocale;
    const preferredLocale = languageTagToSupportedLocale[userRedirectLocale];
    // 현재 locale과 사용자 선호 locale이 다르면 리다이렉트
    if (preferredLocale !== currentLocale) {
      router.replace({ pathname }, { locale: preferredLocale });
      hasRedirectedRef.current = true;
    }
  }, [user, currentLocale, pathname, router, isWebview]);

  return null;
};
